
import { 
    Shift, ShiftAutoFill, ShiftCreate, ShiftDetail
} from "../../types"
import { ApiShift } from "../../../../services";
import { 
    shiftAutoFill,
    shiftClose,
    shiftCreate,
    shiftCurrent,
    shiftDetail,
    shiftOpen
} from "../../actions";
import { makeRequestWithSpinner } from "../../../../worker";
import { call } from "@redux-saga/core/effects";
import { ActionPromise } from "bus/rootActions";


export function* fetchShiftCurrent (): Generator {
    try {
        const options = {
            fetcher: ApiShift.getShiftCurrent,
            startFetching: shiftCurrent.start,
            stopFetching: shiftCurrent.stop,
            fill: shiftCurrent.fill,
            setErrorAction: shiftCurrent.error,
        }

        yield makeRequestWithSpinner<Shift, void>(options)
    } catch(e) {
        
    }
}

export function* fetchShiftOpen (): Generator {
    try {
        const options = {
            fetcher: ApiShift.shiftOpen,
            startFetching: shiftOpen.start,
            stopFetching: shiftOpen.stop,
            fill: shiftOpen.fill,
            setErrorAction: shiftOpen.error,
        }

        yield makeRequestWithSpinner<void, void>(options)

        yield call(fetchShiftCurrent)
    } catch(e) {
        
    }
}

export function* fetchShiftClose (): Generator {
    try {
        const options = {
            fetcher: ApiShift.shiftClose,
            startFetching: shiftClose.start,
            stopFetching: shiftClose.stop,
            fill: shiftClose.fill,
            setErrorAction: shiftClose.error,
        }

        yield makeRequestWithSpinner<void, void>(options)

        window.location.hash='logout-auth';
        
    } catch(e) {
        
    }
}


export function* fetchShiftCreate ({ payload, resolve }: ActionPromise<void, ShiftCreate>): Generator {
    try {
        const options = {
            fetcher: ApiShift.shiftCreate,
            startFetching: shiftCreate.start,
            stopFetching: shiftCreate.stop,
            fill: shiftCreate.fill,
            setErrorAction: shiftCreate.error,
            fetcherParam: payload
        }

        yield makeRequestWithSpinner<void, ShiftCreate>(options);

        yield resolve();
    } catch(e) {
        
    }
}



export function* fetchShiftDetail ({ payload, resolve }: ActionPromise<void, ShiftDetail>): Generator {
    try {
        const options = {
            fetcher: ApiShift.shiftDetail,
            startFetching: shiftDetail.start,
            stopFetching: shiftDetail.stop,
            fill: shiftDetail.fill,
            setErrorAction: shiftDetail.error,
            fetcherParam: payload
        }

        const result = yield makeRequestWithSpinner<void, ShiftDetail>(options);

        yield resolve(result as any);
    } catch(e) {
        
    }
}


export function* fetchShiftAutoFillWorker ({ payload, resolve }: ActionPromise<void, ShiftAutoFill>): Generator {
    try {
        const options = {
            fetcher: ApiShift.autoFill,
            startFetching: shiftAutoFill.start,
            stopFetching: shiftAutoFill.stop,
            fill: shiftAutoFill.fill,
            setErrorAction: shiftAutoFill.error,
            fetcherParam: payload
        }

        yield makeRequestWithSpinner<void, ShiftAutoFill>(options);

        yield resolve();
    } catch(e) {
        
    }
}